import React from "react";

import { Container, SafeModeIcon, ICON_WIDTH } from "./styles";
import { useNavigation } from "@react-navigation/native";

const SafeModeButton = () => {
	const navigation = useNavigation();
	return (
		//@ts-ignore
		<Container onPress={() => navigation.navigate("Safe Mode")}>
			<SafeModeIcon width={ICON_WIDTH} height={ICON_WIDTH} />
		</Container>
	);
};

export default SafeModeButton;
